import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { TextField, Button, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const YeniDestekTalepForm = ({ onSubmit, onCancel, themeColor, themeColorDark, initialValues = {}, durumlar = [] }) => {
    const { handleSubmit, control, formState: { errors }, reset } = useForm({
        defaultValues: initialValues,
    });

    useEffect(() => {
        if (initialValues) {
            reset({
                DESTEK_DURUM_ID: initialValues.DESTEK_DURUM_ID || '',
                DESTEK_BASLIK: initialValues.DESTEK_BASLIK || '',
                DESTEK_ICERIK: initialValues.DESTEK_ICERIK || '',
            });
        }
    }, [initialValues, reset]);

    const formatDateForInput = (dateInput) => {
        if (!dateInput) return '';
        let date;
        if (typeof dateInput === 'object' && dateInput.year) {
            date = new Date(dateInput.year, dateInput.month - 1, dateInput.day || dateInput.dayOfMonth);
        } else if (typeof dateInput === 'string') {
            date = new Date(dateInput);
        } else { return ''; }
        if (isNaN(date.getTime())) { return ''; }
        return date.toLocaleDateString('tr-TR');
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            {initialValues.DESTEK_ID && (
                <>
                    <TextField
                        label="Tarih"
                        value={formatDateForInput(initialValues.ZAMAN)}
                        fullWidth
                        margin="normal"
                        InputProps={{ readOnly: true }}
                    />
                    <Controller
                        name="DESTEK_DURUM_ID"
                        control={control}
                        render={({ field }) => (
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Destek Durumu</InputLabel>
                                <Select {...field} label="Destek Durumu">
                                    {durumlar.map(durum => (
                                        <MenuItem key={durum.DESTEK_DURUM_ID} value={durum.DESTEK_DURUM_ID}>
                                            {durum.DESTEK_DURUM_ADI}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                    />
                </>
            )}
            <Controller name="DESTEK_BASLIK" control={control} rules={{ required: 'Başlık alanı zorunludur.' }}
                render={({ field }) => (
                    <TextField {...field} label="Destek Başlığı" fullWidth margin="normal" error={!!errors.DESTEK_BASLIK} helperText={errors.DESTEK_BASLIK?.message} />
                )}
            />
            <Controller name="DESTEK_ICERIK" control={control} rules={{ required: 'İçerik alanı zorunludur.' }}
                render={({ field }) => (
                    <TextField {...field} label="Destek Mesajınız" fullWidth multiline rows={4} margin="normal" error={!!errors.DESTEK_ICERIK} helperText={errors.DESTEK_ICERIK?.message} />
                )}
            />
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                <Button onClick={onCancel} sx={{ color: 'gray' }}>İptal</Button>
                <Button type="submit" variant="contained" sx={{ backgroundColor: themeColor, '&:hover': { backgroundColor: themeColorDark } }}>
                    {initialValues.DESTEK_ID ? 'Güncelle' : 'Talep Gönder'}
                </Button>
            </Box>
        </form>
    );
};

export default YeniDestekTalepForm;